import { attributeIsSet } from "../../../components/scenes/Tenants/Forms/flagConstants";
import { getFilledArrayOrDefault } from "../../../utils";
import { MinMaxAvg } from "./constantsTyped";

export function applyCategoryFilter(categories, layer) {
    // filter categories based meta fields e.g. country or sup_ref
    return categories.filter((category) => {
        // If meta_conditions is not present or not an array, keep the category
        if (!category.meta_conditions || !Array.isArray(category.meta_conditions)) {
            return true;
        }

        return category.meta_conditions.every((meta) => {
            if (!meta.field || !meta.meta_location) {
                return true;
            }

            const value = layer[meta.field];

            if (meta.include_values && meta.include_values.length > 0) {
                if (!meta.include_values.includes(value)) {
                    return false;
                }
            }

            if (meta.exclude_values && meta.exclude_values.length > 0) {
                if (meta.exclude_values.includes(value)) {
                    return false;
                }
            }

            return true;
        });
    });
}

export const find_category = (value, categories) => {
    let cat;

    if (!attributeIsSet(value)) {
        return false;
    }

    // * First try to find category by exact value match
    cat = getFilledArrayOrDefault(categories).find((i) => (i.value && String(value) === String(i.value))
        || (attributeIsSet(i.eq) && String(value) === String(i.eq))
        || (i.label && String(value).toLowerCase() === String(i.label).toLowerCase()));
    if (typeof cat !== "undefined") {
        return cat;
    }
    const valueAsNumber = Number(value);

    if (Number.isNaN(valueAsNumber)) {
        return false;
    }

    cat = getFilledArrayOrDefault(categories).find((i) => {
        if (attributeIsSet(i.gte) && valueAsNumber < i.gte) {
            return false;
        }
        if (attributeIsSet(i.lt) && valueAsNumber >= i.lt) {
            return false;
        }
        if (attributeIsSet(i.gt) && valueAsNumber <= i.gt) {
            return false;
        }
        if (attributeIsSet(i.lte) && valueAsNumber > i.lte) {
            return false;
        }
        if (attributeIsSet(i.eq) && valueAsNumber !== Number(i.eq)) {
            return false;
        }

        return true;
    });

    if (typeof cat === "undefined") {
        return false;
    }
    return cat;
};

export const value_to_category = (val, categories) => {
    const NoStage = {
        label: "-",
        color: "muted",
    };

    if (val === null || val === undefined || Number.isNaN(val) || val === "") {
        return NoStage;
    }

    const cat = find_category(val, categories);

    if (cat === false) {
        return NoStage;
    }

    return cat;
};

const isDefined = (i) => i !== null && typeof i !== "undefined";

export const calculateMinMaxAvg = (values, unity): MinMaxAvg => {
    values = values.filter(isDefined);
    let avg_raw: number | null = null;
    let avg: string | number = "-";
    let min:string | number = "-";
    let max: string | number = "-";
    if (values.length > 0) {
        const sumWithInitialValue = values.reduce((previousValue, nextValue) => parseFloat(previousValue) + parseFloat(nextValue), 0);
        avg_raw = sumWithInitialValue / values.length;
        avg = `${(avg_raw).toFixed(2)} ${unity}`;
        min = Math.min(...values);
        max = Math.max(...values);
        min = isDefined(min) ? `${(min).toFixed(2)} ${unity}` : "-";
        max = isDefined(max) ? `${(max).toFixed(2)} ${unity}` : "-";
    }
    return {
        min, max, avg, avg_raw
    };
};

export const calculateAbsoluteDifference = (value1: number, value2: number) => {
    return Math.abs(value1 - value2);
};
